const getLocalRefreshToken = () => {
  const user = JSON.parse(localStorage.getItem('user'))
  return user?.refresh_token
}

const getLocalAccessToken = () => {
  const user = JSON.parse(localStorage.getItem('user'))
  return user?.access_token
}

const getLocale = () => {
  const userInfo = JSON.parse(localStorage.getItem('user_info'))
  return userInfo?.locale ? userInfo?.locale : 'en-US'
}

const isAdmin = () => {
  const userInfo = JSON.parse(localStorage.getItem('user_info'))
  if (userInfo?.is_admin) {
    return true
  }

  return false
}

const getUserInfo = () => {
  return JSON.parse(localStorage.getItem('user_info'))
  // if (userInfo) {
  //   return userInfo
  // }

  // let info = await UseApi.GetUserInfo().then((response) => {
  //   if (response.status !== 200) {
  //     return ''
  //   }
  //   localStorage.setItem('user_info', JSON.stringify(response.data))
  //   console.log('done')
  //   return response.data
  // })

  // return info
}

// async function _getUserInfo() {
//   let userInfo = JSON.parse(localStorage.getItem('user_info'))
//   if (userInfo) {
//     return userInfo
//   }
//   return UseApi.GetUserInfo().then((response) => {
//     if (response.status !== 200) {
//       return ''
//     }
//     localStorage.setItem('user_info', JSON.stringify(response.data))
//     console.log('done')
//     return response.data
//   })

//   return userInfoLoading
// }

// function getUserInfoFun() {
//   UseApi.GetUserInfo().then((response) => {
//     if (response.status !== 200) {
//       return
//     }
//     localStorage.setItem('user_info', JSON.stringify(response.data))
//     return response.data
//   })
// }

const updateLocalAccessToken = (token) => {
  let user = JSON.parse(localStorage.getItem('user'))
  user.access_token = token
  localStorage.setItem('user', JSON.stringify(user))
}

const getUser = () => {
  return JSON.parse(localStorage.getItem('user'))
}

const setUser = (user) => {
  localStorage.setItem('user', JSON.stringify(user))
}

const removeUser = () => {
  localStorage.removeItem('user')
  localStorage.removeItem('user_info')
}

const TokenService = {
  getLocalRefreshToken,
  getLocalAccessToken,
  updateLocalAccessToken,
  getUser,
  setUser,
  removeUser,
  isAdmin,
  getUserInfo,
  getLocale,
}

export default TokenService
